import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { adminRoutes } from './admin'

// 路由懒加载
const Login = () => import('@/views/auth/Login.vue')
const Register = () => import('@/views/auth/Register.vue')
const QRLogin = () => import('@/views/auth/QRLogin.vue')
const Dashboard = () => import('@/views/Dashboard.vue')
const UserAgreement = () => import('@/views/legal/UserAgreement.vue')
const PrivacyPolicy = () => import('@/views/legal/PrivacyPolicy.vue')
const Profile = () => import('@/views/user/Profile.vue')
const FeedbackManagement = () => import('@/views/user/FeedbackManagement.vue')
const QuizList = () => import('@/views/quiz/QuizList.vue')
const QuizStartPage = () => import('@/views/quiz/QuizStartPage.vue')
const QuizAnswerPage = () => import('@/views/quiz/QuizAnswerPage.vue')
const QuizResultPage = () => import('@/views/quiz/QuizResultPage.vue')
const WrongQuestions = () => import('@/views/quiz/WrongQuestions.vue')
const QuizHistory = () => import('@/views/quiz/QuizHistory.vue')
const Exam = () => import('@/views/exam/Exam.vue')
const ExamHistory = () => import('@/views/exam/ExamHistory.vue')
const WechatLoginTest = () => import('@/views/WechatLoginTest.vue')
const InviteCenter = () => import('@/views/growth/InviteCenter.vue')

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresGuest: true }
  },
  {
    path: '/auth/qr-login',
    name: 'QRLogin',
    component: QRLogin,
    meta: { requiresGuest: true }
  },
  {
    path: '/auth/qr-login-success',
    name: 'QRLoginSuccess',
    component: () => import('@/views/auth/QRLoginSuccess.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/auth/qr-login-error',
    name: 'QRLoginError',
    component: () => import('@/views/auth/QRLoginError.vue'),
    meta: { requiresGuest: true }
  },
  {
    path: '/invite',
    name: 'InviteCenter',
    component: InviteCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/feedbacks',
    name: 'UserFeedbackManagement',
    component: FeedbackManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/quiz',
    name: 'QuizList',
    component: QuizList,
    meta: { requiresAuth: true }
  },
  {
    path: '/quiz/start',
    name: 'QuizStart',
    component: QuizStartPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/quiz/session/:sessionId',
    name: 'QuizAnswer',
    component: QuizAnswerPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/quiz/result/:sessionId',
    name: 'QuizResult',
    component: QuizResultPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/quiz/history',
    name: 'QuizHistory',
    component: QuizHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/wrong-questions',
    name: 'WrongQuestions',
    component: WrongQuestions,
    meta: { requiresAuth: true }
  },
  {
    path: '/exam',
    name: 'Exam',
    component: Exam,
    meta: { requiresAuth: true }
  },
  {
    path: '/exam/history',
    name: 'ExamHistory',
    component: ExamHistory,
    meta: { requiresAuth: true }
  },
  // 法律页面路由
  {
    path: '/legal/user-agreement',
    name: 'UserAgreement',
    component: UserAgreement
  },
  {
    path: '/legal/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
      path: '/test/wechat-login',
      name: 'WechatLoginTest',
      component: WechatLoginTest,
    },
  // 管理员路由
  ...adminRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  // 检查是否需要认证
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
    return
  }
  
  // 检查是否需要游客状态
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    next('/')
    return
  }
  
  // 检查角色权限
  if (to.meta.requiredRole && authStore.isAuthenticated) {
    const userRole = authStore.user?.role || 'user'
    const roleHierarchy = {
      user: 1,
      admin: 2,
      super_admin: 3
    }
    
    const requiredLevel = roleHierarchy[to.meta.requiredRole as keyof typeof roleHierarchy] || 1
    const userLevel = roleHierarchy[userRole as keyof typeof roleHierarchy] || 1
    
    if (userLevel >= requiredLevel) {
      next()
    } else {
      next('/')
    }
  } else {
    next()
  }
})

export default router
